import SmoothScroll from "smooth-scroll";

export default function() {
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 500,
        speedAsDuration: true,
        updateURL: false
    });
}